import _ from 'lodash';
import { StateService } from '@/services/state.service';

export const SessionService = {
	defaultSession: {
		classSchedules: {
			mode: 'week',
			selectedDate: null
		}
	},
	setValue(path, value) {
		const memberSession = this.loadSession();
		if (memberSession) {
			_.set(memberSession, path, value);
			this.saveSession(memberSession);
		}
	},
	getValue(path) {
		const memberSession = this.loadSession();
		if (!memberSession) return null;
		return _.get(memberSession, path, null);
	},
	saveSession(sessionData) {
		if (StateService.hasSessionStorage) {
			StateService.setSessionKey('member-session', JSON.stringify(sessionData));
		}
	},
	loadSession() {
		if (!StateService.hasSessionStorage) return null;
		return StateService.getSessionJson('member-session') || this.defaultSession;
	}
};
